function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg50N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.84,
    height: 35.629,
    viewBox: "0 0 30.84 35.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "50n"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184503"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184502"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184498"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14447",
    d: "M268.217 191.183a4.444 4.444 0 0 0-4.388-3.437 4.567 4.567 0 0 0-2.794.945 7.952 7.952 0 0 0-7.1-4.255 7.822 7.822 0 0 0-7.853 6.65 5.282 5.282 0 0 0-4.235 5.085 5.335 5.335 0 0 0 5.417 5.215h19.383a5.335 5.335 0 0 0 5.417-5.215 5.263 5.263 0 0 0-3.847-4.988z",
    transform: "translate(-241.843 -176.33)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184623"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14526",
    d: "M3.469 10.138A5.168 5.168 0 0 1 0 8.8h.334A5.518 5.518 0 0 0 4.767 0a5.152 5.152 0 0 1-1.3 10.136z",
    transform: "rotate(105.01 14.333 13.245)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14527",
    d: "M3.329.694A.147.147 0 0 0 3.43.62L3.772 0l.34.62a.147.147 0 0 0 .1.074l.694.133-.483.516a.141.141 0 0 0-.039.119l.088.7-.639-.3a.141.141 0 0 0-.125 0l-.641.3.088-.7a.145.145 0 0 0-.037-.119L2.635.827zM.293 3.573l.057-.454A.145.145 0 0 0 .311 3L0 2.668l.448-.082a.152.152 0 0 0 .1-.074l.219-.391.221.391a.145.145 0 0 0 .1.074l.448.084L1.22 3a.151.151 0 0 0-.039.119l.057.453-.412-.2a.151.151 0 0 0-.125 0zm3.8 1.214a.147.147 0 0 0-.037.119l.057.452-.412-.2a.145.145 0 0 0-.063-.014.139.139 0 0 0-.063.014l-.412.2.057-.452a.149.149 0 0 0-.039-.119l-.313-.332.448-.086a.149.149 0 0 0 .1-.072l.221-.4.219.4a.149.149 0 0 0 .1.072l.448.086z",
    transform: "rotate(105.01 14.603 12.306)",
    style: {
      fill: "#283593"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184625"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 47 \\u2013 4"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14451",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 28.904 13.685)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14452",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 27.504 9.243)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14453",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 32.37 7.904)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14454",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 33.055 12.287)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14455",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 30.971 3.46)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14451",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 35.016 3.014)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14452",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 33.616 -1.429)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14453",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 38.481 -2.768)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14454",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 39.166 1.615)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14525",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 36.366 6.772)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14455",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 37.082 -7.211)",
    style: {
      fill: "#283593"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184501"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184499"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14448",
    d: "M266.03 191.266a6.281 6.281 0 0 1 5.088-2.716.376.376 0 0 0 0-.752 7.077 7.077 0 0 0-5.738 3.088c-.279.4.373.774.65.38z",
    transform: "translate(-259.051 -178.795)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184500"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14449",
    d: "M246.365 218.167a4.088 4.088 0 0 1 1.917-3.406c.407-.26.03-.912-.38-.65a4.866 4.866 0 0 0-2.289 4.055.376.376 0 0 0 .752 0z",
    transform: "translate(-244.606 -198.045)",
    style: {
      fill: "#fff"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50N);
export default __webpack_public_path__ + "static/media/50N.6a1f4671a509e32bd7978611dcca92e4.svg";
export { ForwardRef as ReactComponent };